import { render, staticRenderFns } from "./ot-pagination.vue?vue&type=template&id=4fb6b602&scoped=true&"
import script from "./ot-pagination.vue?vue&type=script&lang=ts&"
export * from "./ot-pagination.vue?vue&type=script&lang=ts&"
import style0 from "./ot-pagination.vue?vue&type=style&index=0&id=4fb6b602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6b602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
